import * as React from "react";
import AccountsPage from "../accounts/components/pages/AccountsPage";

const BanksScreen: React.FC = () => <AccountsPage accountType="bank" />;

export default BanksScreen;
